import getLocalStorage from './getLocalStorage';
import removeLocalStorage from './removeLocalStorage';
import setLocalStorage from './setLocalStorage';

export default {
  getItem: getLocalStorage,
  removeItem: removeLocalStorage,
  setItem: setLocalStorage,
};
